import { createClient } from '@supabase/supabase-js';

// Replace these with your Supabase project credentials
// You can find these in your Supabase project settings at: https://app.supabase.com
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
